<template>
    <div class="mr-10 flex overflow-x-auto">
        <div  v-for="c in compseries" :key="c.name">
            <SensorStatusGraph :series="c"></SensorStatusGraph>
        </div>
    </div>
</template>

<script>

import SensorStatusGraph from './SensorStatusGraph';
import MapboxglHelper from "../../../helpers/settings/mapboxgl";
import * as moment from "moment";

export default {
  name: 'SensorStatusGraphs',
  components: {
    SensorStatusGraph
  },
  props: {
    observations:[],
    H24Parameters:[]
  },
  data() {
    return {
      compseries: []
    };
  },
  mounted() {
  },
  watch: {
    observations() {
        this.loadInitialData();
    }
  },
  methods: {
    async loadInitialData () {
      let mseries = []
      //One serie for each component
      var unique = [...new Set(this.observations.map(o => o.component))]; //
      
      let compmeasurements;
      for(var u = 0; u < unique.length; u++){
          compmeasurements  = this.observations.filter(o => o.component === unique[u]); // all measurements for this component
          let d = [];
          for(var m = 0; m < compmeasurements.length; m++){
            for (let i = 0; i < compmeasurements[m].AggObservations.length; i++) {
              if(compmeasurements[m].AggObservations[i].avg != -9900){ 
                  d.push([compmeasurements[m].AggObservations[i].timestamp_to_epoch * 1000, compmeasurements[m].AggObservations[i].avg])
              }
            }
          }
          if(d.length>0){
              d.sort(function(a,b){
                  return a[0] - b[0];
              });
              let plband = this.getParamPlotBands(unique[u]);
              mseries.push({name : unique[u], data: d, plotBands: plband});
          }
      } 

      this.compseries = mseries;
    },
    getParamPlotBands(param){
        let setting = this.H24Parameters.find(p => {
            return p.name === param
        });
        if(setting){
            let plbands = [];
            //By using the name of the parameter we find the corresponding color schema used by mapbox and create the plotband objects needed for highcharts
            for(var index = 0; index < MapboxglHelper.sensorstatus.colorcodesparam[setting.colorcodes].length; index++){
                let c = MapboxglHelper.sensorstatus.colorcodesparam[setting.colorcodes][index];
                if(c[0] !== -9999){
                    if(index !== MapboxglHelper.sensorstatus.colorcodesparam[setting.colorcodes].length - 1)
                    {
                        plbands.push({from: c[0], to: MapboxglHelper.sensorstatus.colorcodesparam[setting.colorcodes][index + 1][0], color: MapboxglHelper.hexToRgb(c[1], ".8")});
                    }
                }
            }
            return plbands;
        }
        return []
    },
    //This methods returns the maximum value for the grap
    //Not in use, but can be used as max on the y-axis if the graphs should be plotted with all bandcolors on default
    getMaxValue(plband, avgs){
        let maxplband = Math.max.apply(Math, plband.map(function(p) { return p.to; }))
        let maxavgarr = avgs.map(function(x){return x[1]});
        let maxavg =  Math.max.apply( null, maxavgarr );
        return maxplband > maxavg ? maxplband : maxavg;
    }
  }



};
</script>

<style lang="scss" scoped>

  </style>


